export default __webpack_public_path__ + "static/media/gym-img-04.54d74f42.jpg";